import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwarePeriscopeClassicRoute: InvariantJiraRoute = {
	name: 'software-periscope-classic',
	path: '/jira/software/c/projects/:projectKey/development',
};
